import TubCommon from "./tubCommon";

export default class WalkInTubFixture extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'walk_in_tub_fixture';
    this.visible = true;
    this.partName = 'Walk In Tub Fixture';
    this.translateId = "visualizer.bathroom.shower_tub_combo.walk_in_tub_fixture";
    this.bottomTubId = "walk_in_tub";
    this.canBeDisabled = true;
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerComboParent = this.getParent();
    if (showerComboParent.walkInTub && showerComboParent.walkInTub.activeFeature
      && !showerComboParent.walkInTub.disabled) {
      conditions.push({
        propName: "MatchingFeature",
        propValue: showerComboParent.walkInTub.activeFeature.metaData["ActualDisplayedName"]
      });
    }
    return conditions
  }

}
